import { Button, ButtonProps } from '@mui/material'
import React from 'react';

interface ContactButtonProps extends ButtonProps {
  onClick?: () => void;
}

const ContactButton: React.FC<ContactButtonProps> = ({ onClick }) => {

  return (
    <Button 
      variant="outlined" 
      component="a"
      onClick={onClick}
      sx={{
        fontSize: "1.2rem",
        color: 'inherit',
        p: "1rem 2rem", 
        border: "1px solid #fff", 
        borderRadius: "36px", 
        background: "transparent",
        '&:hover': {
          backgroundColor: '#fff',
          borderColor: '#0a0a0a',
          color: '#0a0a0a',
          boxShadow: 'none',
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: '#fff',
          color: '#0a0a0a',
          borderColor: '#0a0a0a',
        },
      }} 
    >
      Contact
    </Button>
  )
}

export default ContactButton;